import React, {
  PropTypes as T,
} from 'react';
import radium from 'radium';
import { connect } from 'react-redux';
import { Link as link } from 'react-router';

const Link = radium(link);

const styles = {
  wrap: {
    padding: '0 24px'
  },
  list: {
    margin: 0,
    padding: 0,
  },
  item: {
    listStyle: 'none',
    height: 36,
    margin: '26px 0 0 0',
    borderBottom: '2px solid rgba(163, 150, 113, 0.5)',
    color: '#a39671',
    letterSpacing: 5,
    fontSize: 18,
    lineHeight: '36px',
    fontWeight: 300,
    cursor: 'pointer',
    display: 'block',
    textDecoration: 'none'
  },
};

function SpecificationList(props) {
  return (
    <div style={styles.wrap}>
      <div style={styles.list}>
        {props.list.map((spec, index) => (
          <Link to={`/specifications/${spec.key}`} style={styles.item} key={index}>{spec.name}</Link>
        ))}
      </div>
    </div>
  );
}

SpecificationList.propTypes = {
  list: T.array,
};

export default connect(
  state => ({
    list: state.Specification.list,
  }),
)(radium(SpecificationList));



// WEBPACK FOOTER //
// ./containers/Specifications/SpecificationList.js